module.exports = __webpack_public_path__ + "img/yuanfudao.e0c8e434.png";